// extracted by mini-css-extract-plugin
export default {"footer":"ImportFileModal-module__footer--uo6C0"};